//? React
import { useState } from "react";

//? External
import { Badge } from "react-bootstrap";
import { FaListUl } from "react-icons/fa";
import { useSelector } from "react-redux";

//* Constants
import { UserRole } from "../../constants/enum/UserRole";

//* Data hook
import { useQuestionCart } from "../../hooks/questionCart/useQuestionCart";

//* Drawer
import QuestionCartDrawer from "./QuestionCartDrawer";

/**
 * Floating cart button (bottom-right) showing the item count. Visible only
 * for ADMIN and TEACHER roles.
 */
export default function QuestionCartButton() {
  const token = useSelector((state: any) => state.auth.token);
  const role = useSelector((state: any) => state.auth.me?.role?.slug);

  const [show, setShow] = useState(false);

  const { count } = useQuestionCart(token);

  const canUseCart = role === UserRole.ADMIN_USER || role === UserRole.TEACHER_USER;

  if (!canUseCart) {
    return null;
  }

  return (
    <>
      <button
        id="btn-open-question-cart"
        type="button"
        aria-label="Abrir lista de questões"
        onClick={() => setShow(true)}
        style={{
          position: "fixed",
          bottom: "24px",
          right: "24px",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          border: "none",
          backgroundColor: "#0d6efd",
          color: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
          zIndex: 1050,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FaListUl size={22} />
        {count > 0 && (
          <Badge
            bg="danger"
            pill
            style={{ position: "absolute", top: "-4px", right: "-4px" }}
          >
            {count}
          </Badge>
        )}
      </button>

      <QuestionCartDrawer show={show} onHide={() => setShow(false)} />
    </>
  );
}
